import produce from 'immer';
export const getQueryFieldName = query => {
  return query.definitions[0].name.value;
};
export const queryDataFromCache = (query, variables, client) => {
  const queryDataWrapper = client.cache.readQuery({
    query,
    variables
  });
  if (queryDataWrapper) {
    if ('result' in queryDataWrapper) {
      return queryDataWrapper.result;
    }
  }
  return null;
};
export const updateCache = (query, updateFn, variables, client) => {
  client.cache.writeQuery({
    query,
    data: {
      result: produce(queryDataFromCache(query, variables, client) || {}, updateFn)
    },
    variables
  });
};